import React from 'react'
import LangPicker from './LangPicker';
import { useIntl } from 'react-intl';

export type FooterProps = {};

const Footer: React.FC<FooterProps> = () => {
  const intl = useIntl();
  return (
    <div className="bg-main min-h-[400px] w-full flex flex-col p-4 md:p-10 pb-0">
      <div className="w-full max-w-6xl flex flex-row flex-wrap m-auto">
        <div className="w-full sm:w-1/2 lg:w-1/4 min-h-[400px] flex items-center justify-center flex-col">
          <img src="/icons/mcb.svg" alt="MCB logo" className='w-[225px]' />
          <div className="flex flex-row justify-center items-center p-4 gap-2">
            <a href="https://www.linkedin.com/company/mexico-certifying-body-s-c" target='blank'><img src="/icons/linkedin-footer.svg" className=" cursor-pointer" alt="linkedin" /></a>
            <img src="/icons/tiktok-footer.svg" className=" cursor-pointer" alt="linkedin" />
            <img src="/icons/insta-footer.svg" className=" cursor-pointer" alt="linkedin" />
          </div>
        </div>
        <div className="w-full sm:w-1/2 lg:w-1/4 mb-8 md:mb-0 md:min-h-[400px] px-3 flex flex-col gap-2 pt-10">
          <h4 className='text-2xl text-secondary font-bold uppercase whitespace-nowrap'>
            {
              intl.formatMessage({
                id: "quick-links",
                defaultMessage: "Quick Links"
              })
            }
          </h4>
          <a className="text-white text-md md:mt-4 border-b border-color-secondary hover-text-secondary whitespace-nowrap" href="/">
            {
              intl.formatMessage({
                id: 'start',
                defaultMessage: 'Start'
              })
            }
          </a>
          <a className="text-white text-md border-b border-color-secondary whitespace-nowrap hover-text-secondary" href="/about-us">
            {
              intl.formatMessage({
                id: 'about_us',
                defaultMessage: 'About Us?'
              })
            }
          </a>
          <a className="text-white text-md border-b border-color-secondary whitespace-nowrap hover-text-secondary" href="/certification-services/process-of-certification">
            {
              intl.formatMessage({
                id: 'cert_services',
                defaultMessage: 'Certification Services'
              })
            }
          </a>
          <a className="text-white text-md border-b border-color-secondary whitespace-nowrap hover-text-secondary" href="/general-info/public-info">
            {
              intl.formatMessage({
                id: 'general_info',
                defaultMessage: 'General Information'
              })
            }
          </a>
          <a className="text-white text-md border-b border-color-secondary whitespace-nowrap hover-text-secondary" href="/news">
            {
              intl.formatMessage({
                id: 'news',
                defaultMessage: 'News'
              })
            }
          </a>
          <a className="text-white text-md whitespace-nowrap hover-text-secondary" href="/contact/meet-us">
            {
              intl.formatMessage({
                id: 'contact',
                defaultMessage: 'Contact Us'
              })
            }
          </a>

        </div>
        <div className="w-full lg:w-1/2 px-3 pb-6 md:pb-8 md:pl-24 md:pt-10 flex flex-col gap-2">
          <h4 className='text-2xl text-secondary font-bold uppercase whitespace-nowrap md:mb-4'>
            {
              intl.formatMessage({
                id: "contact_info",
                defaultMessage: "Contact Info"
              })
            }
          </h4>
          <p className="text-white text-md">Av. Insurgentes Sur 800, Int. Piso 11 Oficina 1 D</p>
          <p className="text-white text-md">Del Valle Centro, C.P. 03100</p>
          <p className="text-white text-md">Benito Juárez, Ciudad de México.</p>
        </div>
      </div>
      <div className="w-full flex flex-row px-3 md:px-0 md:justify-center items-center gap-4 flex-wrap">
        <div className="flex flex-col md:flex-row text-white gap-2">
          <button className="text-white text-xl cursor-pointer bg-transparent border-none p-0 hover:underline text-left">
            {
              intl.formatMessage({
                id: 'privacy',
                defaultMessage: 'Privacy'
              })
            }
          </button>
          
          <button className="text-white text-xl cursor-pointer bg-transparent border-none p-0 hover:underline text-left">
            {
              intl.formatMessage({
                id: 'user-agreement',
                defaultMessage: 'User Agreement'
              })
            }
          </button>
          
          <button className="text-white text-xl cursor-pointer bg-transparent border-none p-0 hover:underline text-left">
            {
              intl.formatMessage({
                id: 'transparency',
                defaultMessage: 'Transparency'
              })
            }
          </button>
          
          <button className="text-white text-xl cursor-pointer bg-transparent border-none p-0 hover:underline text-left">
            {
              intl.formatMessage({
                id: 'cookies-policy',
                defaultMessage: 'Cookies Policy'
              })
            }
          </button>
          
        </div>
        <div className="w-full lg:w-1/2 flex gap-2 flex-col md:flex-row justify-center">
          <p className="text-white text-sm">2024 Mexico Certifying Body S.C, All rights reserved.</p>
          <LangPicker />
        </div>
       
      </div>
    </div>
  );
}

export default Footer;
